import { Type } from '@sinclair/typebox';
import { makeNullable } from '../../utils/typeboxHelpers';

const publicEquipmentSchema = Type.Object({
    id: Type.String(),
    equipment: Type.Object({
        id: Type.String(),
        name: Type.String(),
        manufacturer: Type.String(),
        serialNumber: Type.String(),
        status: Type.String(),
        dateEndCertificateValidity: makeNullable(Type.String()),
        dateReminderRecertification: makeNullable(Type.String()),
        equipmentType: Type.Object({
            name: Type.String(),
            isPayload: Type.Boolean(),
            payloadTo: makeNullable(Type.String()),
            hasLog: Type.Boolean(),
        }),
    }),
});

export const publicEquipmentUsagePaths = {
    '/api/public/surveyEquipment': {
        get: {
            operationId: 'publicEquipmentControllers.getSurveyEquipment',
            parameters: [{ name: 'surveyId', in: 'query', schema: Type.String({ format: 'uuid' }), required: true }],
            responses: {
                '200': {
                    description: 'Equipment used in survey. Custom field values are included as direct properties on the equipment object.',
                    content: {
                        'application/json': {
                            schema: Type.Array(publicEquipmentSchema),
                        },
                    },
                },
            },
        },
    },
} as const;
